import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ChangePassword } from "src/app/core/models/nuevo-usuario";
import { Observable } from "rxjs";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class ChangePasswordService {
  changePasswordURL = endpointsURL.changePasswordURL;
  env = environment.env;
  constructor(private httpClient: HttpClient) {}

  public changePassword(password: any): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.changePasswordURL}edit`,
      password
    );
  }

  public requestChangePasswordRecovery(
    changePassword: ChangePassword
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.changePasswordURL}requestPasswordChange`,
      changePassword
    );
  }

  public changePasswordRecovery(
    changePassword: ChangePassword
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.changePasswordURL}passwordChange`,
      changePassword
    );
  }
}
